import NavbarDrawer from "../drawers/NavbarDrawer";
import Sidebar from "./Sidebar";

interface SidebarMobileProps {
  isOpen: boolean;
  handleClose: () => void;
  isBottomBarVisible: boolean;
}

const SidebarMobile = ({
  isOpen,
  handleClose,
  isBottomBarVisible,
}: SidebarMobileProps) => {
  return (
    <NavbarDrawer
      isOpen={isOpen}
      onClose={handleClose}
      isBottomBarVisible={isBottomBarVisible}
    >
      <div className="h-full w-full overflow-y-auto overflow-x-hidden">
        <Sidebar isMobile={true} handleCollapse={handleClose} />
      </div>
    </NavbarDrawer>
  );
};

export default SidebarMobile;
